// The Admin navigation and theme scope read from this one list, so a route cannot
// be themed without being navigable or the reverse. Paths are unchanged from the
// original sidebar; only their grouping and some labels are new.

export const ADMIN_NAV = Object.freeze([
  { id: 'overview', label: 'Visão geral', icon: 'LayoutDashboard', items: [
    { label: 'Início', path: '/admin-panel-dashboard', icon: 'Home' },
    { label: 'Análises', path: '/admin/analytics', icon: 'BarChart3' },
  ] },
  { id: 'learning', label: 'Aprendizagem', icon: 'BookOpen', items: [
    { label: 'Operações de Aprendizagem', path: '/admin/learning-operations', icon: 'CalendarClock' },
    { label: 'Cursos', path: '/admin/courses', icon: 'Book' },
    { label: 'Módulos', path: '/admin/modules', icon: 'Layers' },
    { label: 'Aulas', path: '/admin/lessons', icon: 'FileText' },
    { label: 'Aulas para revisar', path: '/admin/lesson-reviews', icon: 'ClipboardCheck', badge: 'lessonReviews' },
    { label: 'Atividades', path: '/admin/activities', icon: 'CheckSquare' },
    { label: 'Biblioteca', path: '/admin/library', icon: 'Archive' },
  ] },
  { id: 'people', label: 'Pessoas', icon: 'Users', items: [
    { label: 'Todos os usuários', path: '/admin/users', icon: 'Users' },
    { label: 'Estudantes', path: '/admin/students', icon: 'GraduationCap' },
    { label: 'Instrutores', path: '/admin/instructors', icon: 'UserCheck' },
    { label: 'Administradores', path: '/admin/admins', icon: 'Shield' },
    { label: 'Matrículas', path: '/admin/enrollments', icon: 'BookOpen' },
  ] },
  { id: 'certificates', label: 'Certificados', icon: 'Award', items: [
    { label: 'Modelos', path: '/certificate-management-interface', icon: 'FileImage' },
    { label: 'Emitidos', path: '/certificate-management-interface?tab=issued', icon: 'FileCheck' },
    { label: 'Validação', path: '/certificate-management-interface?tab=validation', icon: 'Search' },
    { label: 'Configurações', path: '/certificate-management-interface?tab=settings', icon: 'Settings' },
  ] },
  { id: 'business', label: 'Negócio', icon: 'CreditCard', items: [
    { label: 'Provedores de pagamento', path: '/payment-management-interface', icon: 'Building' },
    { label: 'Transações', path: '/payment-management-interface?tab=transactions', icon: 'Receipt' },
    { label: 'Controle de acesso', path: '/payment-management-interface?tab=access', icon: 'Lock' },
    { label: 'Relatórios de pagamento', path: '/payment-management-interface?tab=reports', icon: 'BarChart3' },
    { label: 'Afiliados', path: '/admin/affiliates', icon: 'Users2' },
    { label: 'Relatórios de afiliados', path: '/admin/affiliates/reports', icon: 'TrendingUp', disabled: true },
    { label: 'Configurar afiliados', path: '/admin/affiliates/settings', icon: 'Settings', disabled: true },
    { label: 'Relatório de aprendizado', path: '/admin/reports/learning', icon: 'BookOpen', disabled: true },
  ] },
  { id: 'communication', label: 'Comunicação', icon: 'Mail', items: [
    { label: 'Campanhas', path: '/admin/comms/campaigns', icon: 'Megaphone' },
    { label: 'Modelos de mensagem', path: '/admin/comms/templates', icon: 'FileText' },
    { label: 'Envios', path: '/admin/comms/sends', icon: 'Send', disabled: true },
  ] },
  { id: 'settings', label: 'Configurações', icon: 'Settings', items: [
    { label: 'Tema e marca', path: '/admin/settings/theme-white-label', icon: 'Palette' },
    { label: 'Mapeamento de mídia', path: '/admin/settings/media-mapping', icon: 'Link' },
    { label: 'Mídia e player', path: '/admin/settings/media-player', icon: 'PlayCircle', disabled: true },
    { label: 'E-mail', path: '/admin/settings/email', icon: 'Mail', disabled: true },
    { label: 'Logs e auditoria', path: '/admin/system/logs', icon: 'FileText' },
    { label: 'Backup', path: '/admin/system/backup', icon: 'Database' },
    { label: 'Integrações', path: '/admin/system/integrations', icon: 'Plug', disabled: true },
  ] },
]);

// Routes that are Admin but reached from inside a screen rather than the menu.
const ADMIN_ONLY_PATHS = [
  '/admin-course-management', '/content-management-interface', '/user-management-interface', '/theme-settings-panel',
  '/media-library-management', '/affiliate-management-interface', '/communication-campaign-management',
  '/system-administration-interface', '/campaign-creation-form', '/campaign-creation-wizard', '/email-template-editor',
  '/email-template-builder', '/media-mapping-configuration', '/content-module-editor', '/system-backup-configuration',
  '/request-management-interface',
];

const ADMIN_PATHS = new Set([...ADMIN_ONLY_PATHS, ...ADMIN_NAV.flatMap(group => group.items.map(item => item.path.split('?')[0]))]);

export function isAdminPath(pathname) {
  if (!pathname) return false;
  const path = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  return ADMIN_PATHS.has(path) || path.startsWith('/admin/');
}

// Screens whose whole import tree has no repo, RPC or table (scripts/admin-inventory.mjs).
// They render sample content, so they say so: design must not turn a mock into a feature.
export const PROTOTYPE_PATHS = Object.freeze([
  '/admin/analytics', '/theme-settings-panel', '/admin/settings/theme-white-label', '/media-library-management',
  '/certificate-management-interface', '/affiliate-management-interface', '/admin/affiliates', '/admin/affiliates/reports',
  '/admin/affiliates/settings', '/communication-campaign-management', '/admin/comms/campaigns', '/admin/comms/sends',
  '/system-administration-interface', '/admin/system/logs', '/admin/system/integrations', '/campaign-creation-form',
  '/email-template-editor', '/campaign-creation-wizard', '/email-template-builder', '/admin/comms/templates',
  '/admin/settings/media-mapping', '/admin/settings/media-player', '/admin/settings/email', '/admin/reports/learning',
  '/admin/system/backup', '/system-backup-configuration', '/request-management-interface',
]);
